import { observer } from "mobx-react"

const Roadmap = observer(() => {
    return (<>
        <section className="roadmap-section py-5" id="roadmap">
    <h2 className="weird-subtitle text-center">Roadmap</h2>
    <div className="container text-center d-flex">
        <img
            className="roadmap-image w-25"
            src="assets/img/snowball4.png"
            alt="Roadmap Image"
        />
        <div className="timeline">
            <div className="timeline-item" data-description=" • Smart Contract Deployment: SnowballBoss will launch on Binance Smart Chain (BSC).
">
                <div className="timeline-dot" />
                🚀 Launch & Initial Growth
            </div>
            <div className="timeline-item" data-description=" • Airdrop Campaigns: Distribute tokens to early adopters and community members.
">
                <div className="timeline-dot" />
                🌍 Community Building
            </div>
            <div className="timeline-item" data-description="• NFT Collection Launch: Snowball-themed NFTs will be released to engage the 
">
                <div className="timeline-dot" />
                🎉 Growth & Expansion
            </div>
            <div className="timeline-item" data-description=" • Cross-chain Integration: Expand SnowballBoss availability on other blockchains like 
Ethereum and Solana.">
                <div className="timeline-dot" />
                ⚙️ Scaling
            </div>
        </div>
    </div>
</section>

    </>)
});

export default Roadmap;